var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMaxMinimize(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 62,
    viewBox: "0 0 51 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.6667 32C30.6624 32.851 30.4687 33.6903 30.0997 34.4571C29.7307 35.2239 29.1957 35.899 28.5333 36.4333L11.5333 50.4667C10.5099 51.2867 9.27668 51.8027 7.97423 51.9559C6.67178 52.1092 5.35248 51.8934 4.16667 51.3333C3.13609 50.8791 2.25805 50.1378 1.63741 49.1979C1.01678 48.2581 0.679782 47.1595 0.666671 46.0333L0.66667 17.9667C0.67978 16.8405 1.01678 15.7419 1.63741 14.8021C2.25805 13.8622 3.13609 13.1209 4.16667 12.6667C5.35248 12.1066 6.67178 11.8908 7.97423 12.0441C9.27668 12.1973 10.5099 12.7133 11.5333 13.5333L28.5333 27.5667C29.1957 28.101 29.7307 28.7761 30.0997 29.5429C30.4687 30.3097 30.6624 31.149 30.6667 32Z",
    fill: "#79889A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 3.5H47V58.5H34.5",
    stroke: "#79889A",
    strokeWidth: 7,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaxMinimize);
export default __webpack_public_path__ + "static/media/max-minimize.c3b2c6f3.svg";
export { ForwardRef as ReactComponent };